export default {
    en: {},
    et: {
        name:'Nimi',
        is_active: 'Aktiivne',
        updated_at: 'Uuendatud',
        accounts_connected:'Kombineeritud konto',
        comment:'Kirjeldus',
        title:{
            create_role:'Loo uus roll',
            create_user:'Loo uus kasutaja'
        },
        role_name:'Rolli nimi',
        role: {
            delete_title: 'Rolli kustutamine',
            delete_notice: 'Oled kindel, et soovid selle rolli kustutada?'
        },
        user:{
            email: 'E-posti aadress',
            alis_id: 'ALIS ID',
            alis_username: 'ALIS kasutajanimi',
            roles: 'Rollid'
        }
    },
}